import { useEffect, useRef, useState } from "react";
import { PackagingRecordsViewModel } from "../../viewmodels/packaging/PackagingRecordsViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import {
  convertToTwoDecimals,
  formatDateWithTime,
  withRouter,
} from "../../shared/utility";

import SlideOver from "../../components/slideOver/SlideOver";
import EmptyModal from "../../components/modals/EmptyModal";
import ExpandableDataTable from "../../components/tables/ExpandableDataTable";

import { useNavigate } from "react-router-dom";
import { Paginator } from "primereact/paginator";
import { classNames } from "primereact/utils";
import ButtonSpinner from "../../components/controls/ButtonSpinner";

import ReportsDropdown from "../../components/filterDropdown/ReportsDropdown";
import StatsComponents from "../../components/stats/StatsComponents";
import LoadingSvg from "../../components/spinners/LoadingSvg";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";

function isPalletPackagingRow(row) {
  return String(row?.carton_type ?? "").toLowerCase() === "pallet";
}

function PackagingRecords(props) {
  const { logout, addSnackbar } = props;
  const {
    askDeletePackaging,
    emptyModal,
    setEmptyModelOpen,
    getPackagings,
    loading,
    packagings,
    setSlideOver,
    slideOver,
    packagingReprintAll,
    bulkActionInProgress,
    reprintSinglePackagingLabel,
    askDeletePackagingLot,
    deleteMultiplePackaging,
    openPackagingDetailsSideView,
    fetchBrandsForDropdown,
    getEmployeesForDropdown,
    filters,
    showFilters,
    resetFilters,
    filterComponents,
    setShowFilters,
    generatePackagingReport,
    reportComponents,
    showReports,
    setShowReports,
    reportInProgress,
    analytics,
    getPackagingSubItems,
    fetchPalletExpand,
    packagingSubItems,
    palletExpandChildren,
    palletExpandLoading,
    fetchProductsForDropdown,
    getProductTypes,
    setShowDates,
    showDates,
    setFilters,
  } = PackagingRecordsViewModel(logout, addSnackbar);

  const navigate = useNavigate();

  const currentPageRef = useRef(1);
  useEffect(() => {
    fetchBrandsForDropdown();
    getEmployeesForDropdown(2, [1, 2]);
    getEmployeesForDropdown(1, [1, 2]);
    fetchProductsForDropdown();
    getProductTypes();
    getPackagings(null, currentPageRef.current, filters);
  }, []);

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);

  const searchRef = useRef();

  const handleSearch = () => {
    setExpandedRows({});
    setNestedExpandedRowsByParentId({});
    setCheckedSubItemsByParentId({});
    setSubItemsByParentId({});
    setSubItemsLoadingByParentId({});
    subItemsSyncParentIdRef.current = null;
    getPackagings(searchRef.current.value, currentPageRef.current, filters);
  };

  const handlePagination = (event) => {
    currentPageRef.current = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    setExpandedRows({});
    setNestedExpandedRowsByParentId({});
    setCheckedSubItemsByParentId({});
    setSubItemsByParentId({});
    setSubItemsLoadingByParentId({});
    subItemsSyncParentIdRef.current = null;
    getPackagings(searchRef.current.value, currentPageRef.current, filters);
  };

  const [expandedRows, setExpandedRows] = useState({});
  const [nestedExpandedRowsByParentId, setNestedExpandedRowsByParentId] =
    useState({});
  const [checkedSubItemsByParentId, setCheckedSubItemsByParentId] = useState(
    {},
  );
  const [subItemsByParentId, setSubItemsByParentId] = useState({});
  const [subItemsLoadingByParentId, setSubItemsLoadingByParentId] = useState(
    {},
  );
  const fetchGenerationByParentIdRef = useRef({});
  const subItemsSyncParentIdRef = useRef(null);

  const subItemType = (row) =>
    isPalletPackagingRow(row) ? "pallet" : "carton";
  const subItemKey = (row) => `${subItemType(row)}_${row.id}`;

  const allowGroupedPackagingExpansion = () => true;

  const handleGroupedPackagingExpand = async (row) => {
    const parentId = row.id;
    const requestGeneration =
      (fetchGenerationByParentIdRef.current[parentId] ?? 0) + 1;
    fetchGenerationByParentIdRef.current[parentId] = requestGeneration;

    setNestedExpandedRowsByParentId((prev) => ({
      ...prev,
      [parentId]: prev[parentId] ?? {},
    }));
    setCheckedSubItemsByParentId((prev) => ({
      ...prev,
      [parentId]: prev[parentId] ?? {},
    }));
    setSubItemsLoadingByParentId((prev) => ({ ...prev, [parentId]: true }));
    console.log("row", row);
    const items = await getPackagingSubItems(
      row.plu,
      row.lot_number,
      row.packaging_date,
    );

    if (fetchGenerationByParentIdRef.current[parentId] !== requestGeneration) {
      return;
    }

    setSubItemsByParentId((prev) => ({ ...prev, [parentId]: items ?? [] }));
    setSubItemsLoadingByParentId((prev) => ({ ...prev, [parentId]: false }));
  };

  const handlePalletRowExpand = (row) => {
    if (isPalletPackagingRow(row) && row?.barcode) {
      fetchPalletExpand(row.barcode);
    }
  };

  const packagingDateBodyTemplate = (rowData) => {
    return formatDateWithTime(rowData.packaging_converted);
  };

  const packSizeBodyTemplate = (rowData) => {
    return formatDateWithTime(rowData.packing_size) + " kg";
  };

  const totalPackagedBody = (rowData) => {
    return rowData.total_packaged;
  };

  const saleStatusDateBodyTemplate = (rowData) => {
    let bg = "bg-green-600";
    let text = "In Stock";
    if (parseInt(rowData.statustatus) === 1) {
      bg = "bg-red-600";
      text = "Sold";
    } else if (parseInt(rowData.statustatus) === 2) {
      bg = "bg-gray-600";
      text = "Adjusted";
    }
    return (
      <button
        onClick={() => {}}
        className={classNames(
          bg,
          "rounded-md px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm",
        )}
      >
        {text}
      </button>
    );
  };

  const onPackagingReprintAll = async function (itemId, packagingDate) {
    const reprintResult = await packagingReprintAll(itemId, packagingDate);
  };

  const bulkReprintBusy =
    bulkActionInProgress.reprintAllLot != null ||
    bulkActionInProgress.barcode !== "";

  const shippingBarcodeBodyTemplate = (rowData) => {
    return <p>{rowData.barcode}</p>;
  };

  const openBulkDeleteConfirm = (parentId, selectedSubItems) => {
    setEmptyModelOpen({
      open: true,
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          message={`Are you sure you want to delete ${selectedSubItems.length} selected packaging record${selectedSubItems.length === 1 ? "" : "s"}?`}
          confirmAction={async () => {
            subItemsSyncParentIdRef.current = parentId;
            const callResult = await deleteMultiplePackaging(selectedSubItems);
            setCheckedSubItemsByParentId((prev) => ({
              ...prev,
              [parentId]: {},
            }));

            if (callResult?.success) {
              const skipped =
                callResult.data?.not_deleted_packaging_records ?? [];
              const skippedKeys = new Set(
                skipped.map((r) => `${r.type}_${r.id}`),
              );
              const deletedKeys = new Set(
                selectedSubItems
                  .filter((r) => !skippedKeys.has(`${r.type}_${r.id}`))
                  .map((r) => `${r.type}_${r.id}`),
              );

              setSubItemsByParentId((prev) => ({
                ...prev,
                [parentId]: (prev[parentId] ?? []).filter(
                  (item) => !deletedKeys.has(`${subItemType(item)}_${item.id}`),
                ),
              }));
            }
          }}
          setOpen={setEmptyModelOpen}
        />
      ),
    });
  };

  const massItemActionTemplate = (rowData) => {
    return (
      <div className="flex">
        <button
          onClick={() =>
            openPackagingDetailsSideView(rowData.lot_number, rowData.plu)
          }
          className="ml-2 rounded-md bg-yellow-500 px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          disabled={bulkReprintBusy}
        >
          <ButtonSpinner
            spin={bulkActionInProgress.reprintAllLot === rowData.lot_number}
            text="Details"
          />
        </button>
        <button
          onClick={() =>
            onPackagingReprintAll(rowData.lot_number, rowData.packaging_date)
          }
          className="ml-2 rounded-md bg-main-purple px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          disabled={bulkReprintBusy}
        >
          <ButtonSpinner
            spin={bulkActionInProgress.reprintAllLot === rowData.lot_number}
            text="Reprint All"
          />
        </button>
        <button
          onClick={() => {
            askDeletePackagingLot(rowData);
          }}
          className="ml-2 rounded-md bg-red-600 px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          disabled={bulkReprintBusy}
        >
          Delete All
        </button>
      </div>
    );
  };

  const singleItemActionTemplate = (rowData, parentId) => {
    return (
      <div className="flex">
        <button
          onClick={() => reprintSinglePackagingLabel(rowData.barcode)}
          className="ml-2 rounded-md bg-main-purple px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          disabled={bulkReprintBusy}
        >
          <ButtonSpinner
            spin={bulkActionInProgress.barcode === rowData.barcode}
            text="Reprint"
          />
        </button>
        <button
          onClick={() => {
            subItemsSyncParentIdRef.current = parentId;
            askDeletePackaging(rowData);
          }}
          className="ml-2 rounded-md bg-red-600 px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          disabled={bulkReprintBusy}
        >
          Delete
        </button>
      </div>
    );
  };

  const palletSingleCartonReprintActionTemplate = (rowData) => {
    return (
      <div className="flex">
        <button
          onClick={() => reprintSinglePackagingLabel(rowData.barcode)}
          className="ml-2 rounded-md bg-main-purple px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          disabled={bulkReprintBusy}
        >
          <ButtonSpinner
            spin={bulkActionInProgress.barcode === rowData.barcode}
            text="Reprint"
          />
        </button>
      </div>
    );
  };

  const stockInWeightBody = (rowData) => {
    return <p>{convertToTwoDecimals(rowData.stock_in_weight)} kg</p>;
  };

  const productNameWithDescriptionTemplate = (rowData) => {
    const description =
      rowData.description_en ?? rowData.description ?? rowData.descriptionEn;

    return (
      <div className="min-w-0">
        <div className="font-medium text-gray-900 truncate">
          {rowData.product_name}
        </div>
        {description ? (
          <div className="text-gray-500 text-xs leading-4 line-clamp-2">
            {description}
          </div>
        ) : null}
      </div>
    );
  };

  const buildSubItemColumns = (items, parentId) => {
    const checkedSubItems = checkedSubItemsByParentId[parentId] ?? {};
    const selectedSubItems = Object.values(checkedSubItems);
    const allSelected =
      items.length > 0 && items.every((r) => checkedSubItems[subItemKey(r)]);
    const someSelected =
      items.some((r) => checkedSubItems[subItemKey(r)]) && !allSelected;

    const toggleAll = () => {
      setCheckedSubItemsByParentId((prev) => {
        const nextForParent = { ...(prev[parentId] ?? {}) };
        if (allSelected) {
          items.forEach((r) => {
            delete nextForParent[subItemKey(r)];
          });
        } else {
          items.forEach((r) => {
            nextForParent[subItemKey(r)] = { id: r.id, type: subItemType(r) };
          });
        }
        return { ...prev, [parentId]: nextForParent };
      });
    };

    return [
      {
        header: (
          <div className="flex justify-center">
            <input
              type="checkbox"
              checked={allSelected}
              ref={(el) => {
                if (el) el.indeterminate = someSelected;
              }}
              onChange={toggleAll}
              className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
              aria-label="Select all sub-items"
            />
          </div>
        ),
        width: "3%",
        body: (r) => (
          <div className="flex justify-center">
            <input
              type="checkbox"
              checked={checkedSubItems[subItemKey(r)]}
              onChange={() =>
                setCheckedSubItemsByParentId((prev) => {
                  const k = subItemKey(r);
                  const nextForParent = { ...(prev[parentId] ?? {}) };
                  if (nextForParent[k]) {
                    delete nextForParent[k];
                  } else {
                    nextForParent[k] = { id: r.id, type: subItemType(r) };
                  }
                  return { ...prev, [parentId]: nextForParent };
                })
              }
              className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
              aria-label={`Select ${subItemType(r)} ${r.id}`}
            />
          </div>
        ),
      },
      {
        header: "Name",
        body: (r) => productNameWithDescriptionTemplate(r),
        width: "20%",
      },
      { field: "lot_number", header: "Lot Number", width: "12%" },
      { field: "carton_count", header: "Carton Count", width: "10%" },
      {
        header: "Barcode",
        body: (r) => shippingBarcodeBodyTemplate(r),
        width: "20%",
      },
      {
        header: "Pack Size",
        body: (r) => packSizeBodyTemplate(r),
        width: "8%",
      },
      { field: "best_before_date", header: "Best Before", width: "8%" },
      {
        field: "statustatus",
        header: "Sale Status",
        body: (r) => saleStatusDateBodyTemplate(r),
        width: "8%",
      },
      {
        header: (
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => openBulkDeleteConfirm(parentId, selectedSubItems)}
              disabled={selectedSubItems.length === 0}
              className={classNames(
                selectedSubItems.length > 0
                  ? "bg-red-600 text-white hover:bg-red-500"
                  : "bg-gray-300 text-gray-600 cursor-not-allowed",
                "rounded-md px-1.5 py-1.5 text-sm font-semibold shadow-sm",
              )}
            >
              Delete
              {selectedSubItems.length > 0
                ? ` (${selectedSubItems.length})`
                : ""}
            </button>
          </div>
        ),
        body: (r) => singleItemActionTemplate(r, parentId),
        width: "5%",
      },
    ];
  };

  const palletSingleCartonColumns = [
    {
      header: "Barcode",
      body: (r) => shippingBarcodeBodyTemplate(r),
      width: "55%",
    },
    {
      header: "Pack Size",
      body: (r) => packSizeBodyTemplate(r),
      width: "25%",
    },
    {
      header: "",
      body: (r) => palletSingleCartonReprintActionTemplate(r),
      width: "20%",
    },
  ];

  const packagingColumns = [
    { field: "plu", header: "PLU", width: "5%" },
    {
      header: "Name",
      body: (r) => productNameWithDescriptionTemplate(r),
      width: "20%",
    },
    { field: "lot_number", header: "Lot Number", width: "6%" },
    { field: "brand_name", header: "Brand", width: "8%" },
    {
      header: "Packaging Date",
      body: (r) => packagingDateBodyTemplate(r),
      width: "11%",
    },
    {
      field: "best_before_date",
      header: " Best Before Date",
      width: "8%",
    },
    {
      header: "Total Packed/Cs",
      body: (r) => totalPackagedBody(r),
      width: "7%",
    },
    {
      header: "Total Packaged",
      body: (r) => stockInWeightBody(r),
      width: "7%",
    },
    {
      header: "",
      body: (r) => massItemActionTemplate(r),
      width: "12%",
    },
  ];

  const renderPalletSingleCartonsRow = (palletRow) => {
    const bc = palletRow?.barcode;
    const cartons = palletExpandChildren[bc] ?? [];
    const palletLoading = !!palletExpandLoading[bc];
    return (
      <div className="p-3 pl-6">
        <ExpandableDataTable
          data={cartons}
          dataKey="id"
          columns={palletSingleCartonColumns}
          loading={palletLoading}
          loadingTemplate={<LoadingSvg />}
          tableClassName="min-w-full bg-white divide-y divide-gray-300"
          cellClassName="py-2 bg-gray-100 border-1-bottom-gray px-2 text-sm"
        />
      </div>
    );
  };

  useEffect(() => {
    const parentId = subItemsSyncParentIdRef.current;
    if (parentId == null) return;
    setSubItemsByParentId((prev) => ({
      ...prev,
      [parentId]: packagingSubItems,
    }));
  }, [packagingSubItems]);

  const renderExpandedPackagingRow = (parentRow) => {
    const parentId = parentRow.id;
    const packagingSubItemsForParent = subItemsByParentId[parentId] ?? [];
    const checkedSubItems = checkedSubItemsByParentId[parentId] ?? {};
    const nestedExpandedRows = nestedExpandedRowsByParentId[parentId] ?? {};
    const selectionRenderKey = packagingSubItemsForParent
      .map((r) => `${subItemKey(r)}:${checkedSubItems[subItemKey(r)] ? 1 : 0}`)
      .join("|");

    return (
      <div className="p-3">
        <ExpandableDataTable
          key={`${parentId}:${selectionRenderKey}`}
          data={packagingSubItemsForParent}
          dataKey="id"
          columns={buildSubItemColumns(packagingSubItemsForParent, parentId)}
          loading={subItemsLoadingByParentId[parentId] ?? false}
          loadingTemplate={<LoadingSvg />}
          expandable
          allowExpansion={isPalletPackagingRow}
          onRowExpand={handlePalletRowExpand}
          renderExpandedRow={renderPalletSingleCartonsRow}
          expandedRows={nestedExpandedRows}
          onExpandedRowsChange={(rows) =>
            setNestedExpandedRowsByParentId((prev) => ({
              ...prev,
              [parentId]: rows,
            }))
          }
          tableClassName="min-w-full bg-white divide-y divide-gray-300"
          cellClassName="py-2 bg-gray-100 border-1-bottom-gray px-2 text-sm"
          wrapperClassName="w-full overflow-x-auto"
        />
      </div>
    );
  };

  return (
    <div>
      <div className="hide-for-print">
        <div className="px-4 sm:px-6 lg:px-8">
          <StatsComponents
            analytics={analytics}
            setFilters={setFilters}
            filters={filters}
            setShowDates={setShowDates}
            showDates={showDates}
            handleSearch={handleSearch}
            filtersEnabled={true}
            showFilters={showFilters}
            filterComponents={filterComponents}
            resetFilters={resetFilters}
            setShowFilters={setShowFilters}
          />
          <div className="mt-4 sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Packaging Records
              </h1>
              <div className="mt-5 block sm:flex rounded-md space-y-4 sm:space-y-0 gap-2">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchPackaging"
                    id="searchPackaging"
                    className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                    placeholder="Search by packaging name or plu"
                    ref={searchRef}
                    onKeyDown={(e) =>
                      e.key === "Enter" ? handleSearch() : null
                    }
                  />

                  <button
                    type="button"
                    className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                    onClick={() => handleSearch()}
                  >
                    <MagnifyingGlassIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </button>
                </div>

                <div className="flex">
                  <div>
                    <button
                      className="ml-2 rounded-md bg-main-purple px-2 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      onClick={() => navigate("/packaging-new")}
                    >
                      Create packaging
                    </button>
                  </div>

                  <ReportsDropdown
                    actionCall={generatePackagingReport}
                    reportComponents={reportComponents}
                    showReports={showReports}
                    setShowReports={setShowReports}
                    title="Reports"
                    reportInProgress={reportInProgress}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <div className="overflow-hidden card-custom bg-white">
                  <ExpandableDataTable
                    data={packagings.data ?? []}
                    dataKey="id"
                    columns={packagingColumns}
                    loading={loading}
                    loadingTemplate={
                      <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                          Loading
                        </div>
                      </div>
                    }
                    emptyMessage="No packaging records found"
                    expandable
                    allowExpansion={allowGroupedPackagingExpansion}
                    onRowExpand={handleGroupedPackagingExpand}
                    renderExpandedRow={renderExpandedPackagingRow}
                    expandedRows={expandedRows}
                    onExpandedRowsChange={setExpandedRows}
                    tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
                    cellClassName="p-2 bg-white border-1-bottom-gray text-sm"
                    wrapperClassName="w-full"
                  />
                </div>
              </div>
              <div className="w-full">
                <Paginator
                  first={first}
                  rows={rows}
                  totalRecords={packagings.total ?? 0}
                  onPageChange={handlePagination}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        fullScreen={true}
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PackagingRecords),
);
